// Общите парчета на модалите за устройство (POS/фискален): превключвател,
// eyebrow етикет, картата на секция, хедърът ѝ и блокът „Пример".

export const EYEBROW_CLASS =
  "text-[10.5px] font-bold uppercase tracking-[1.2px] text-muted";

const SWITCH_SIZES = {
  lg: { track: "h-[26px] w-[46px]", knob: "top-[3px] h-5 w-5", on: "left-[23px]", off: "left-[3px]" },
  sm: { track: "h-5 w-[34px]", knob: "top-[2px] h-4 w-4", on: "left-4", off: "left-[2px]" },
};

// Самата писта с топчето — за редове, в които целият ред е бутонът.
export const DeviceSwitchTrack = ({ checked, size }: { checked: boolean; size: "lg" | "sm" }) => {
  const sizing = SWITCH_SIZES[size];
  return (
    <span
      className={`relative shrink-0 rounded-full transition-colors ${sizing.track} ${
        checked ? "bg-brand" : "bg-fill-3"
      }`}
    >
      <span
        className={`absolute rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.2)] transition-[left] duration-150 ${sizing.knob} ${
          checked ? sizing.on : sizing.off
        }`}
      />
    </span>
  );
};

// Превключвател с етикет вляво — целият ред е бутонът.
export const DeviceSwitch = ({
  checked,
  label,
  size,
  onChange,
  className = "",
}: {
  checked: boolean;
  label: string;
  size: "lg" | "sm";
  onChange: (checked: boolean) => void;
  className?: string;
}) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    onClick={() => onChange(!checked)}
    className={`flex shrink-0 cursor-pointer items-center gap-2 rounded-[8px] px-1.5 py-1 text-[13px] text-ink hover:bg-shade-1 ${
      size === "lg" ? "font-bold" : "font-semibold"
    } ${className}`}
  >
    {label}
    <DeviceSwitchTrack checked={checked} size={size} />
  </button>
);

// Бялата карта на секция (Документи / Кухненски билети).
export const DeviceSectionCard = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-col overflow-hidden rounded-[14px] border border-shade-2 bg-surface">
    {children}
  </div>
);

// Хедърът на секция: икона + заглавие + действие на един ред, описанието
// отдолу на цялата ширина. На телефон разделът (табът) вече носи заглавието —
// остават само краткото описание и действието, на един ред.
export const DeviceSectionHeader = ({
  icon,
  iconClassName,
  title,
  description,
  shortDescription,
  action,
  isNarrow,
}: {
  icon: React.ReactNode;
  iconClassName: string;
  title: string;
  // Може да липсва — тогава под заглавието няма текст.
  description?: string;
  shortDescription: string;
  action?: React.ReactNode;
  isNarrow: boolean;
}) =>
  isNarrow ? (
    <div className="flex items-center gap-3 border-b border-shade-2 px-4 py-3">
      <div className="min-w-0 flex-1 text-[13px] leading-[1.45] text-body">
        {shortDescription}
      </div>
      {action}
    </div>
  ) : (
    <div className="flex flex-col gap-1.5 border-b border-shade-2 px-4 py-3">
      <div className="flex items-center gap-2.5">
        <span
          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-[10px] ${iconClassName}`}
        >
          {icon}
        </span>
        <div className="min-w-0 flex-1 truncate text-[14px] font-bold leading-[1.3] text-ink">
          {title}
        </div>
        {action}
      </div>
      {description && (
        <div className="text-[12px] leading-[1.45] text-body [text-wrap:pretty]">{description}</div>
      )}
    </div>
  );

// Блокът „Пример" под хедъра на секция — само на по-широко от телефон.
export const DeviceExampleBlock = ({ children }: { children: React.ReactNode }) => (
  <div className="border-b border-shade-2 bg-panel px-4 py-2.5">{children}</div>
);
